/* global axios */
import ApiClient from '../ApiClient';

// The Voice page of an assistant: the compiled prompt (text and voice), the blocks and voice fields that can be
// edited, publishing with a reason, drift against the voice provider, versions and the audit log.
class PolarisVoicePrompt extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  path(assistantId) {
    return `${this.url}/${assistantId}/voice_prompt`;
  }

  show(assistantId) {
    return axios.get(this.path(assistantId));
  }

  update(assistantId, { promptBlocks, voice }) {
    return axios.patch(this.path(assistantId), {
      voice_prompt: { prompt_blocks: promptBlocks, voice },
    });
  }

  publish(assistantId, reason) {
    return axios.post(`${this.path(assistantId)}/publish`, { reason });
  }

  drift(assistantId) {
    return axios.get(`${this.path(assistantId)}/drift`);
  }

  versions(assistantId, page = 1) {
    return axios.get(`${this.path(assistantId)}/versions`, {
      params: { page },
    });
  }

  version(assistantId, versionNo) {
    return axios.get(`${this.path(assistantId)}/versions/${versionNo}`);
  }

  restore(assistantId, versionNo, reason) {
    return axios.post(
      `${this.path(assistantId)}/versions/${versionNo}/restore`,
      { reason }
    );
  }

  auditEvents(assistantId, page = 1) {
    return axios.get(`${this.path(assistantId)}/audit_events`, {
      params: { page },
    });
  }
}

export default new PolarisVoicePrompt();
